export default __webpack_public_path__ + "static/media/item1.e6a6a55a.jpg";